import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { MadfarmInput } from "../../../../ui/molecules/input/newInput"
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static"
import TextArea from "../../../../ui/molecules/textArea"
import { skillLevels } from "../../../../utils"
import { OtherInfoUpdate, OtherInfoValidation, resetErrorLabel, resetOtherInfoUpdateForm, resetOtherInfoValidationStatus, setUpdateDrivingLicense, setUpdateNativeLanguage, setUpdateOralExpressionSkill, setUpdateOrganizationalSkill, setUpdateOtherLanguage, setUpdateOtherSkill, setUpdatePersonalSkill, setUpdateReadSkill, setUpdateRelationalSkill, setUpdateTechnicalSkill, setUpdateWriteSkill } from "../slice"

interface Props {
    close: () => void;
}

export default function EditOtherInfo(props: Props) {
    const dispatch = useAppDispatch()
    const otherInfoState = useAppSelector(state => state.PMOtherInfo)

    useEffect(() => {
        if (otherInfoState.OtherInfoValidationStatus === 'successfully') {
            dispatch(resetOtherInfoValidationStatus())
            dispatch(resetErrorLabel())
            if (otherInfoState.OthInfoUpdateRequest.id) {
                dispatch(OtherInfoUpdate({ data: otherInfoState.OthInfoUpdateRequest, id: otherInfoState.OthInfoUpdateRequest.id }))
                props.close()
                dispatch(resetOtherInfoUpdateForm())
            }
        }
    }, [otherInfoState.OtherInfoValidationStatus])

    return (
        <>
            <div className="p-6 bg-white flex flex-col gap-6">

                {otherInfoState.errorLabel && (
                    <div className="rounded-lg bg-red-100 px-4 py-3">
                        <span className="text-sm font-semibold text-red-700">
                            {otherInfoState.errorLabel}
                        </span>
                    </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <MadfarmInput
                        label="Patente (Es. A, A1, B, ecc.)"
                        placeholder="Patente"
                        value={otherInfoState.OthInfoUpdateRequest.drivingLicense}
                        defaultValue={otherInfoState.OthInfoUpdateRequest.drivingLicense}
                        onChangeText={(text) => dispatch(setUpdateDrivingLicense(text))}
                    />
                    <MadfarmInput
                        label="Madrelingua"
                        placeholder="Madrelingua"
                        value={otherInfoState.OthInfoUpdateRequest.nativeLanguage}
                        defaultValue={otherInfoState.OthInfoUpdateRequest.nativeLanguage}
                        onChangeText={(text) => dispatch(setUpdateNativeLanguage(text))}
                    />
                    <MadfarmInput
                        label="Altre lingue (Francese, Inglese, ecc..)"
                        placeholder="Specificare altre lingue..."
                        value={otherInfoState.OthInfoUpdateRequest.otherLanguage}
                        defaultValue={otherInfoState.OthInfoUpdateRequest.otherLanguage}
                        onChangeText={(text) => dispatch(setUpdateOtherLanguage(text))}
                    />
                </div>

                <div className="border-t border-neutral-200 pt-2">
                    <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">Capacità linguistiche</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Capacità di lettura"
                        placeholder="Specificare capacità"
                        options={skillLevels}
                        value={otherInfoState.OthInfoUpdateRequest.readSkill}
                        defaultValue={otherInfoState.OthInfoUpdateRequest.readSkill}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setUpdateReadSkill(newValue))
                        }}
                        noOptionsMessage={""}
                    />
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Capacità di scrittura"
                        placeholder="Specificare capacità"
                        options={skillLevels}
                        value={otherInfoState.OthInfoUpdateRequest.writeSkill}
                        defaultValue={otherInfoState.OthInfoUpdateRequest.writeSkill}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setUpdateWriteSkill(newValue))
                        }}
                        noOptionsMessage={""}
                    />
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Capacità di espressione orale"
                        placeholder="Specificare capacità"
                        options={skillLevels}
                        value={otherInfoState.OthInfoUpdateRequest.oralExpressionSkill}
                        defaultValue={otherInfoState.OthInfoUpdateRequest.oralExpressionSkill}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setUpdateOralExpressionSkill(newValue))
                        }}
                        noOptionsMessage={""}
                    />
                </div>

                <div className="border-t border-neutral-200 pt-2">
                    <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">Competenze</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <TextArea
                        label="Capacità e competenze personali"
                        placeholder="Specificare capacità..."
                        value={otherInfoState.OthInfoUpdateRequest.personalSkill}
                        defaultValue={otherInfoState.OthInfoUpdateRequest.personalSkill}
                        onChangeText={(text) => dispatch(setUpdatePersonalSkill(text))}
                    />
                    <TextArea
                        label="Capacità e competenze relazionali"
                        placeholder="Specificare capacità..."
                        value={otherInfoState.OthInfoUpdateRequest.relationalSkill}
                        defaultValue={otherInfoState.OthInfoUpdateRequest.relationalSkill}
                        onChangeText={(text) => dispatch(setUpdateRelationalSkill(text))}
                    />
                    <TextArea
                        label="Capacità e competenze organizzative"
                        placeholder="Specificare capacità..."
                        value={otherInfoState.OthInfoUpdateRequest.organizationalSkill}
                        defaultValue={otherInfoState.OthInfoUpdateRequest.organizationalSkill}
                        onChangeText={(text) => dispatch(setUpdateOrganizationalSkill(text))}
                    />
                    <TextArea
                        label="Capacità e competenze tecniche"
                        placeholder="Specificare capacità..."
                        value={otherInfoState.OthInfoUpdateRequest.technicalSkill}
                        defaultValue={otherInfoState.OthInfoUpdateRequest.technicalSkill}
                        onChangeText={(text) => dispatch(setUpdateTechnicalSkill(text))}
                    />
                </div>

                <div className="grid grid-cols-1 gap-4">
                    <TextArea
                        label="Altre capacità e competenze"
                        placeholder="Specificare capacità..."
                        value={otherInfoState.OthInfoUpdateRequest.otherSkill}
                        defaultValue={otherInfoState.OthInfoUpdateRequest.otherSkill}
                        onChangeText={(text) => dispatch(setUpdateOtherSkill(text))}
                    />
                </div>

                <div className="flex justify-end gap-2 pt-4 border-t border-neutral-200">
                    <ButtonComponent
                        size="md"
                        variant="outline"
                        iconPosition="off"
                        label="Annulla"
                        color="gray"
                        onClick={() => props.close()}
                    />
                    <ButtonComponent
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(OtherInfoValidation(otherInfoState.OthInfoUpdateRequest))}
                    />
                </div>
            </div>
        </>
    )
}